import { render } from "./Lightbox.vue?vue&type=template&id=e0f38d76&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"

import "./Lightbox.vue?vue&type=style&index=0&id=e0f38d76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f38d76"]])

export default __exports__